import { PosSessionsControllerFindAll$Params } from '@klubovna/api-client';
import {
  AddHelperDto,
  ClosePosSessionDto,
  CloseSessionResponseDto,
  DetailedSessionStatsDto,
  HelperResponseDto,
  OpenPosSessionDto,
  PosOverallStatsDto,
  PosSession,
  PosSessionStatsDto,
} from '@klubovna/api-client';
import { PaginatedResponse } from '@klubovna/api-client';
import { createAction, props } from '@ngrx/store';

export const ADMIN_POS_SESSIONS_ID = '[POS Sessions admin]';

export const loadPosSessions = createAction(
  ADMIN_POS_SESSIONS_ID + ' Load POS Sessions',
  props<{ params?: PosSessionsControllerFindAll$Params }>(),
);

export const loadPosSessionsSuccess = createAction(
  ADMIN_POS_SESSIONS_ID + ' Load POS Sessions Success',
  props<{ response: PaginatedResponse<PosSession> }>(),
);

export const loadPosSessionsFailure = createAction(
  ADMIN_POS_SESSIONS_ID + ' Load POS Sessions Failure',
  props<{ error: string }>(),
);

export const loadCurrentSession = createAction(
  ADMIN_POS_SESSIONS_ID + ' Load Current Session',
);

export const loadCurrentSessionSuccess = createAction(
  ADMIN_POS_SESSIONS_ID + ' Load Current Session Success',
  props<{ session: PosSession | null }>(),
);

export const loadCurrentSessionFailure = createAction(
  ADMIN_POS_SESSIONS_ID + ' Load Current Session Failure',
  props<{ error: string }>(),
);

export const openSession = createAction(
  ADMIN_POS_SESSIONS_ID + ' Open Session',
  props<{ body: OpenPosSessionDto }>(),
);

export const openSessionSuccess = createAction(
  ADMIN_POS_SESSIONS_ID + ' Open Session Success',
  props<{ session: PosSession }>(),
);

export const openSessionFailure = createAction(
  ADMIN_POS_SESSIONS_ID + ' Open Session Failure',
  props<{ error: string }>(),
);

export const closeSession = createAction(
  ADMIN_POS_SESSIONS_ID + ' Close Session',
  props<{ id: string; body?: ClosePosSessionDto }>(),
);

export const closeSessionSuccess = createAction(
  ADMIN_POS_SESSIONS_ID + ' Close Session Success',
  props<{ response: CloseSessionResponseDto }>(),
);

export const closeSessionFailure = createAction(
  ADMIN_POS_SESSIONS_ID + ' Close Session Failure',
  props<{ error: string }>(),
);

export const loadOverallStats = createAction(
  ADMIN_POS_SESSIONS_ID + ' Load Overall Stats',
  props<{ params?: { dateFrom?: string; dateTo?: string } }>(),
);

export const loadOverallStatsSuccess = createAction(
  ADMIN_POS_SESSIONS_ID + ' Load Overall Stats Success',
  props<{ stats: PosOverallStatsDto }>(),
);

export const loadOverallStatsFailure = createAction(
  ADMIN_POS_SESSIONS_ID + ' Load Overall Stats Failure',
  props<{ error: string }>(),
);

export const loadSessionStats = createAction(
  ADMIN_POS_SESSIONS_ID + ' Load Session Stats',
  props<{ id: string }>(),
);

export const loadSessionStatsSuccess = createAction(
  ADMIN_POS_SESSIONS_ID + ' Load Session Stats Success',
  props<{ stats: PosSessionStatsDto }>(),
);

export const loadSessionStatsFailure = createAction(
  ADMIN_POS_SESSIONS_ID + ' Load Session Stats Failure',
  props<{ error: string }>(),
);

export const loadDetailedStats = createAction(
  ADMIN_POS_SESSIONS_ID + ' Load Detailed Stats',
  props<{ id: string }>(),
);

export const loadDetailedStatsSuccess = createAction(
  ADMIN_POS_SESSIONS_ID + ' Load Detailed Stats Success',
  props<{ stats: DetailedSessionStatsDto }>(),
);

export const loadDetailedStatsFailure = createAction(
  ADMIN_POS_SESSIONS_ID + ' Load Detailed Stats Failure',
  props<{ error: string }>(),
);

export const loadHelpers = createAction(
  ADMIN_POS_SESSIONS_ID + ' Load Helpers',
  props<{ sessionId: string }>(),
);

export const loadHelpersSuccess = createAction(
  ADMIN_POS_SESSIONS_ID + ' Load Helpers Success',
  props<{ helpers: HelperResponseDto[] }>(),
);

export const loadHelpersFailure = createAction(
  ADMIN_POS_SESSIONS_ID + ' Load Helpers Failure',
  props<{ error: string }>(),
);

export const addHelper = createAction(
  ADMIN_POS_SESSIONS_ID + ' Add Helper',
  props<{ sessionId: string; body: AddHelperDto }>(),
);

export const addHelperSuccess = createAction(
  ADMIN_POS_SESSIONS_ID + ' Add Helper Success',
  props<{ session: PosSession }>(),
);

export const addHelperFailure = createAction(
  ADMIN_POS_SESSIONS_ID + ' Add Helper Failure',
  props<{ error: string }>(),
);

export const removeHelper = createAction(
  ADMIN_POS_SESSIONS_ID + ' Remove Helper',
  props<{ sessionId: string; volunteerId: string }>(),
);

export const removeHelperSuccess = createAction(
  ADMIN_POS_SESSIONS_ID + ' Remove Helper Success',
  props<{ session: PosSession }>(),
);

export const removeHelperFailure = createAction(
  ADMIN_POS_SESSIONS_ID + ' Remove Helper Failure',
  props<{ error: string }>(),
);

